/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import GuardianRouteLinkItem from './GuardianRouteLinkItem';
import PhotoIcon from 'icons/PhotoIcon';

const messages = defineMessages({
  title: {id: 'navigation.photo'},
});

const PhotoItem = () => (
  <GuardianRouteLinkItem
    iconBefore={PhotoIcon}
    route="midas/guardian/photo"
    title={messages.title}
  />
);

export default PhotoItem;
